import { OidcClientSettings } from 'oidc-client-ts';

export type Configuration = {
  host: string;
  superset_host: string;
  hostApiNhaxe: string;
  apiV1: {
    accessToken: string;
    basicToken: string;
  };
  hostApiV4: string;
  hostApiLHV: string;
  hostApiTransit: string;
  hostApiTransitOptimize: string;
  hostApiReport: string;
  socketHost: string;
  oidc: Omit<OidcClientSettings, 'redirect_uri' | 'post_logout_redirect_uri'>;
};

export const config: Configuration = {
  host: process.env.API_HOST ?? '',
  hostApiNhaxe: process.env.API_NHAXE ?? '',
  superset_host: process.env.SUPERSET_HOST ?? '',
  apiV1: {
    accessToken: process.env.APIV1_ACCESS_TOKEN ?? '',
    basicToken: process.env.APIV1_BASIC_TOKEN ?? '',
  },
  hostApiV4: process.env.APIV4_HOST ?? '',
  hostApiLHV: process.env.APILHV_HOST ?? '',
  hostApiTransit: process.env.TRANSIT_API_HOST ?? '',
  hostApiTransitOptimize: process.env.TRANSIT_OPTIMIZE_API_HOST ?? '',
  hostApiReport: process.env.REPORT_HOST ?? '',
  socketHost: process.env.SOCKET_HOST ?? '',
  oidc: {
    client_id: process.env.OIDC_CLIENT_ID ?? '',
    response_type: 'code',
    scope: 'openid profile',
    authority: process.env.OIDC_AUTHORITY_URL ?? '',
  },
};
